// 滚动显现动画
const DEFAULT_OPTIONS = {
  threshold: 0.12,
  rootMargin: '0px 0px -40px 0px'
}

/** 使用 IntersectionObserver 监听元素进入视口并添加 is-visible 类 */
function observeElement(el, options) {
  if (typeof IntersectionObserver === 'undefined') {
    el.classList.add('is-visible')
    return null
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return
      entry.target.classList.add('is-visible')
      observer.unobserve(entry.target)
    })
  }, options)

  observer.observe(el)
  return observer
}

/** 滚动渐入指令：元素进入视口时显示动画 */
export default {
  /** 指令挂载时初始化观察器 */
  mounted(el, binding) {
    el.classList.add('scroll-reveal')
    const modifier = binding.arg || binding.value
    if (modifier && typeof modifier === 'string') {
      el.classList.add(`scroll-reveal--${modifier}`)
    }

    el._scrollRevealObserver = observeElement(el, DEFAULT_OPTIONS)
  },
  /** 指令卸载时断开观察器 */
  unmounted(el) {
    if (el._scrollRevealObserver) {
      el._scrollRevealObserver.disconnect()
      delete el._scrollRevealObserver
    }
  }
}
